function iprettyPriceFilter($filter) {
    'ngInject';

    return (number, currencyCode) => $filter('pretty_price')(number, currencyCode);
}

angular
    .module('BB')
    .filter('ipretty_price', iprettyPriceFilter);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_filters/ipretty_price.filter.js